import React from "react";

// Branded wordmark: "Fabric" in an antique letterpress serif, "Archives" in the display face.
export default function CategoryName({ className = "" }) {
  return (
    <span className={className} style={{ textTransform: "none" }} data-testid="category-name">
      <span className="font-antique italic">Fabric</span> Archives
    </span>
  );
}
